import React, { useContext, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import loadable from '@loadable/component';
import { Route, Switch } from 'react-router-dom';
import { getCountrySettings } from './../../../../actions/usersAction'
import MenuPlaceholder from './customMenuContent';
import ManageHolidays from './manageHolidays';
import InventorySiteList from './inventorySiteList';
import AddNewInventorySite from './inventorySiteList/addNewInventorySite';
import NutritionAnalysisSettings from './nutritionAnalysisSettings';
import Vendors from './vendors';
import VendorRec from './vendors/vendorRec';
import StorageLocations from './storageLocations';

const ManageUsers = loadable(() => import('./manageUsers'));
const UserRecord = loadable(() => import('./manageUsers/userRecord'));
const Settings = () => {
    const [countrySettings, setCountrySettings] = useState([]);

    useEffect(() => {
        getCountrySettingsList();
    }, []);

    const getCountrySettingsList = async () => {
        const res = await getCountrySettings();
        if (res.error) {
            setCountrySettings([]);
        } else {
            setCountrySettings(res.data);
        }
    }

    return (
        <Switch>
            <Route path="/settings/manageUsers" exact render={(props) => <ManageUsers {...props} {...{ countrySettings }} />} />
            <Route path="/settings/userRecord" exact render={(props) => <UserRecord {...props} {...{ countrySettings }} />} />
            <Route path="/settings/menuPlaceholders" render={(props) => <MenuPlaceholder {...props} {...{ countrySettings }} />} />
            <Route path="/settings/manageHolidays" render={(props) => <ManageHolidays {...props} {...{ countrySettings }} />} />
            <Route path="/settings/inventorySiteList" exact render={(props) => <InventorySiteList {...props} {...{ countrySettings }} />} />
            <Route path="/settings/addNewInventorySite" exact render={(props) => <AddNewInventorySite {...props} {...{ countrySettings }} />} />
            {/* <Route path="/settings/nutritionAnalysisSettings" exact render={(props) =><NutritionAnalysisSettings {...props } />} /> */}
            <Route path="/settings/nutritionAnalysisSettings" exact render={(props) => <NutritionAnalysisSettings {...props} />} />
            <Route path="/settings/vendors" exact render={(props) => <Vendors {...props} {...{ countrySettings }} />} />
            <Route path="/settings/vendorRec" exact render={(props) => <VendorRec {...props} {...{ countrySettings }} />} />
            <Route path="/settings/storageLocations" exact render={(props) => <StorageLocations {...props} />} />
            <Route path="/settings"
                render={(props) => <ManageUsers {...props} {...{ countrySettings }} />} />
        </Switch>)
}
export default Settings